/*!

=========================================================
* BootstrapVue Argon Dashboard PRO - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/bootstrap-vue-argon-dashboard-pro
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue';
import 'moment'
import axios from 'axios'
import VueAxios from 'vue-axios'
//import VueI18n from 'vue-i18n'

import DashboardPlugin from './plugins/dashboard-plugin';
import JsonEditor from 'vue-json-edit'
import {Select, Option} from 'element-ui'
import loadash from 'lodash'

Vue.prototype.$_ = loadash;

Vue.use(VueAxios, axios)
Vue.use(JsonEditor)

//Vue.use(VueI18n)

const messages = {
  en: {
    message: {
      hello: 'hello world'
    }
  },
  de: {
    classes: {
      DA010: "Produktdatenblatt",
      DC010: "Bedienungsanleitung",
      DC020: "Betriebsanleitung",
      DC070: "Montageanleitung",
      DC090: "Wartungsanleitung",
      FB030: "R&I-Fließschema",
      QC010: "CE-Konformitätserklärung",
      QC040: "Prüfbescheinigung",
      QC070: "Schweißnachweis",
      TB010: "Maßzeichnung",
      TB020: "Isometrie",
      TB030: "Einzelteilzeichnung",
      FA010: "Übersichtsschaltplan",
      TC020: "Zusammenbauzeichnung"
    },

    metadata: {
      is_document_scanned:	"Dokument ist ein Scan?",
      image_creator_software: "Software zur Bildererstellung",
      pdf_creator_software: "Software zur PDF-Erstellung",
      author: "Autor",
      encryption: "Verschlüsselung",
      signatures: "Unterschriften",
      title: "Titel",
      created_date: "Erstellungsdatum",
      mod_date: "Änderungsdatum"
    },
    documentstatus: {
      completed: "Abgeschlossen",
      inprogress: "In Bearbeitung",
      notstarted: "Nicht gestartet",
      failed: "Fehlgeschlagen",
      canceled: "Abgebrochen",
      pending: "Ausstehend",
      queued: "In Warteschlange",
      running: "In Bearbeitung"

    },
    status: {
      HAS_WORD:  "Enthält unerlaubtes Wort",
      PASSED: "Überprüfung bestanden",
      DOCUMENT_MODIFIED: "Dokument wurde verändert",
      ANNOTATION_OVERLAP: "Überlappung von Annotationen",
      BOX_OVERLAP_TEXT_COMPLETE: "Überlappung von Box und Text",
      BOX_OVERLAP_TEXT_NUMBER: "Überlappung von Box und numrischer Text",
      BOX_OVERLAP: "Überlappung von Boxen",
      IMAGE_OUTLIER: "Ein inkosistentes Bild wurde gefunden",
      HAS_ANNOTATIONS: "Es wurden Annotationen gefunden",
      NOT_IN_ALLOWED_LIST: "Nicht in der Erlaubten-Liste",
      MATCHING_ALLOWED_LIST: "Übereinstimmung mit der Erlaubten-Liste",
      IN_DENIED_LIST: "In der Verbotenen-Liste",
      IMAGE_CREATOR_IN_DENY_LIST: "Bild-Erstellungssoftware in der Verbotenen-Liste",
      PDF_CREATOR_IN_DENY_LIST: "PDF-Erstellungssoftware in der Verbotenen-Liste",
      SCAN_DOCUMENT_OUTLIER: "Scanist inkonsistent zu anderen Seiten"
    },
    message: {
      hello: 'hello'
    }
  }
}

// Create VueI18n instance with options
/*const i18n = new VueI18n({
  locale: 'de', // set locale
  messages, // set locale messages
})*/

import App from './App.vue';

// router setup
import router from './routes/router';

// plugin setup
Vue.use(DashboardPlugin);

Vue.use(Select)
Vue.use(Option)

Vue.user_settings = null;

if(location.href.indexOf("localdev") > -1) {
  Vue.prototype.base_url = "https://localdev.ecosystem-manager.co:8090";
} else if(location.href.indexOf("localhost") > -1)  {

  Vue.prototype.base_url = "https://localhost:8090"
}
else if(location.href.indexOf("kido-portal") > -1 || location.href.indexOf("kido-app") > -1)  {
  Vue.prototype.base_url = "https://kido-api.hytechnologies.co"
}
else if(location.href.indexOf("kido-dev") > -1)  {
  Vue.prototype.base_url = "https://kido-dev.hytechnologies.co/api"
} else if(location.href.indexOf("doqument") > -1)  {
  Vue.prototype.base_url = "https://doqument.hytechnologies.co/api"
} else {
  Vue.prototype.base_url = "https://kido.hytechnologies.co/api"
}

Vue.axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    config.withCredentials = true;
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);


if( window.location.pathname.indexOf("/users/") == -1 && window.location.pathname.indexOf("/web/") == -1  ){
 
  // Intercept all responses
  Vue.axios.interceptors.response.use(

    (response) => {
     
      return response;
  },
  (error) => {
     
      let response = error.response;
      let request = error.request;
    
      // all 4xx/5xx responses will end here
      
      if(response && response.status == "401" && request.responseURL.indexOf("/users/refresh_login") != -1  ) {
     
        Vue.axios.get(`${Vue.prototype.base_url}/users/logout`).then(res => {
          
          setTimeout(() => {
            if( window.location.pathname != "/" && window.location.pathname.indexOf("/users/") == -1 && window.location.pathname.indexOf("/web/") == -1  ){
              document.location.reload();
            }
          }, 500);

        }).catch( ex => {
          
          setTimeout(() => {
            if( window.location.pathname != "/" && window.location.pathname.indexOf("/users/") == -1 && window.location.pathname.indexOf("/web/") == -1  ){
              document.location.reload();
            }
          }, 500);
        });

        //Vue.http.headers.common['Authorization'] = 'JWT none';

    } else if(response && response.status == "401" ){
      if(response.data.detail == "token_expired") {
        return Vue.axios.get(`${Vue.prototype.base_url}/users/refresh_login`).then(res => {
          console.log(" refresh response", res )
         
          //retry Request Call
          
          return error.request;
        });
      } else {
        location.href = "/users/login";
      }
    } else if(response && response.status == "403" && request.responseURL.indexOf("/users") == -1  ) {
     
      location.href = "/users/login";
    }

  });
}

Vue.prototype.$t = (key) => { return loadash.get(messages, "de."+key) };

Vue.axios.get(`${Vue.prototype.base_url}/users/me`).then(res => {
  if(res) Vue.prototype.$auth = res.data;

  /* eslint-disable no-new */
  new Vue({
    //i18n,
    el: '#app',
    render: h => h(App),
    router,
    
  });

}, err => {
  /* eslint-disable no-new */
  Vue.prototype.$auth = null;
  new Vue({
    //i18n,
    el: '#app',
    render: h => h(App),
    router,
    
  });
});


